import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22metadata.ts%22,%22import%22:%22Raleway%22,%22arguments%22:[{%22variable%22:%22--font-raleway%22,%22adjustFontFallback%22:true,%22style%22:%22normal%22,%22weight%22:[%22100%22,%22200%22,%22300%22,%22400%22,%22500%22,%22600%22,%22700%22,%22800%22,%22900%22],%22subsets%22:[%22latin%22]}],%22variableName%22:%22raleway%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Raleway', 'Raleway Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
